import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { userSettingGet, userSettingPut } from '../../../../../redux/user/userThunk'
import GenericConfirmModal from './GenericConfirmModal'

export default function AsteriskConfirm({ handleClose, onConfirm }) {
  const dispatch = useDispatch()
  const [isChecked, setIsChecked] = useState(false)
  const settings = useSelector((state) => state.user?.settings)

  return (
    <GenericConfirmModal
      content={
        <>
          <div style={{ textAlign: 'center' }}>
            There are asterisks ( *** ) in your note. Use jump codes (ctrl+h) to identify the
            asterisks.
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '16px',
              marginTop: '24px',
            }}
          >
            <input
              type="checkbox"
              checked={isChecked}
              onChange={(e) => {
                setIsChecked(e?.currentTarget?.checked)
              }}
            />
            <div>Don&apos;t show again for 30 days</div>
          </div>
        </>
      }
      onClose={handleClose}
      onConfirm={async () => {
        if (isChecked) {
          let newUserSettings = {
            ...settings,
            asteriskWarningExpiration: new Date().toISOString(),
          }
          if (Object.keys(newUserSettings)?.length > 1) {
            await dispatch(userSettingPut(newUserSettings))
            dispatch(userSettingGet())
          }
        }
        onConfirm()
      }}
      confirmTxt={'Sign anyway'}
    />
  )
}
